import { render, staticRenderFns } from "./OfferArticleCard.vue?vue&type=template&id=7dd875fc&"
import script from "./OfferArticleCard.vue?vue&type=script&lang=js&"
export * from "./OfferArticleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports